import React, { useEffect, useState } from "react";
import { apiFetch } from "./api";

export default function ChangePasswordModal({ onClose }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape" && !saving) onClose();
    }
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [saving, onClose]);

  async function save() {
    if (newPassword !== repeatPassword) {
      setError("Uued paroolid ei kattu.");
      return;
    }
    if (newPassword.length < 8) {
      setError("Uus parool peab olema vähemalt 8 tähemärki.");
      return;
    }

    setSaving(true);
    setError("");
    try {
      const res = await apiFetch("/api/me/password", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          current_password: currentPassword,
          new_password: newPassword,
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.detail || `Muutmine ebaõnnestus (HTTP ${res.status})`);
      setDone(true);
    } catch (err) {
      console.error("Password change failed", err);
      setError(err.message || "Parooli muutmine ebaõnnestus.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h3 style={styles.title}>Muuda parooli</h3>

        {done ? (
          <>
            <div style={styles.okBox}>Parool on muudetud.</div>
            <div style={styles.actions}>
              <button type="button" onClick={onClose} style={styles.primaryBtn}>
                Sulge
              </button>
            </div>
          </>
        ) : (
          <>
            <label style={styles.label}>Praegune parool</label>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              autoFocus
              style={styles.input}
            />

            <label style={styles.label}>Uus parool (vähemalt 8 tähemärki)</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              style={styles.input}
            />

            <label style={styles.label}>Korda uut parooli</label>
            <input
              type="password"
              value={repeatPassword}
              onChange={(e) => setRepeatPassword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") save();
              }}
              style={styles.input}
            />

            {error && <div style={styles.errBox}>{error}</div>}

            <div style={styles.actions}>
              <button
                type="button"
                onClick={onClose}
                style={styles.secondaryBtn}
                disabled={saving}
              >
                Tühista
              </button>
              <button
                type="button"
                onClick={save}
                disabled={saving || !currentPassword || !newPassword}
                style={
                  saving || !currentPassword || !newPassword
                    ? styles.disabledBtn
                    : styles.primaryBtn
                }
              >
                {saving ? "Salvestan…" : "Salvesta"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1100,
    fontFamily: "'DM Sans', sans-serif",
  },
  modal: {
    background: "white",
    borderRadius: "14px",
    padding: "24px",
    width: "380px",
    boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
  },
  title: { margin: "0 0 16px 0", color: "#0D1F4D", fontSize: "18px" },
  label: {
    display: "block",
    fontWeight: 600,
    color: "#0D1F4D",
    marginBottom: "6px",
    fontSize: "13px",
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
    borderRadius: "10px",
    border: "1px solid #8CA5E6",
    padding: "10px 12px",
    outline: "none",
    background: "#fff",
    fontSize: "14px",
    fontFamily: "'DM Sans', sans-serif",
    marginBottom: "14px",
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "12px",
  },
  primaryBtn: {
    backgroundColor: "#0D1F4D",
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "10px 16px",
    fontWeight: 600,
    cursor: "pointer",
  },
  secondaryBtn: {
    backgroundColor: "#8CA5E6",
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "10px 14px",
    fontWeight: 600,
    cursor: "pointer",
  },
  disabledBtn: {
    backgroundColor: "#D8E1F7",
    color: "#6C7A9A",
    border: "none",
    borderRadius: "8px",
    padding: "10px 16px",
    fontWeight: 600,
    cursor: "not-allowed",
  },
  okBox: {
    background: "#E7F6EC",
    border: "1px solid #B6E2C6",
    color: "#1E8449",
    borderRadius: "8px",
    padding: "10px 12px",
    fontSize: "13px",
    fontWeight: 600,
  },
  errBox: {
    background: "#FDECEA",
    border: "1px solid #F5C6C0",
    color: "#C0392B",
    borderRadius: "8px",
    padding: "10px 12px",
    fontSize: "13px",
    fontWeight: 600,
    marginBottom: "10px",
  },
};
